import { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Map as NewbuildingMapComponent } from '@cian/frontend-newbuilding-map-component';

import { TInfrastructureItem } from '../../../types/map';
import { getGeoCoordinates } from '../../../selectors/newbuilding';

export const useTransportAccessibilityRouting = (mapApi: NewbuildingMapComponent | null) => {
  const routeIdRef = useRef<string>();

  const mainPinCoordinates = useSelector(getGeoCoordinates);

  const setTARouting = useCallback(
    async (item: TInfrastructureItem) => {
      if (!mainPinCoordinates) {
        return;
      }

      const routeId = `customRoute-${item.id}`;
      routeIdRef.current = routeId;

      await mapApi?.addRoute(
        routeId,
        { coordinates: mainPinCoordinates },
        { coordinates: item.coordinates },
        'pedestrian',
      );
    },
    [mapApi, mainPinCoordinates],
  );

  const resetTARouting = useCallback(() => {
    if (routeIdRef.current) {
      mapApi?.removeRoute(routeIdRef.current);
    }
  }, [mapApi]);

  return {
    setTARouting,
    resetTARouting,
  };
};
